<main role="main" class="page-port-du-maroc not-home-page">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <app-breadcrumb></app-breadcrumb>
        <h2>{{"general.communiquespresse" | translate}}</h2>
      </div>
    </div>
  </div>
  <section class="c-actualite">
    <div class="container">
      <!-- <div class="row slickpress slickContent" data-aos="fade-up">
        <div *ngFor="let p of dataPress" style="vertical-align: middle;" class="col-md-4">
          <div class="block-actu">
            <div class="date-actu">{{converteDate(p?.PressDate)}}</div>
            <h3 class="titre-presse">{{p?.Title?.substr(0,95)+'...'}}</h3>
            <p class="actu-resume">
              {{p?.PressDescription?.substr(0,200)+'...'}}
            </p>
            <a class="btn btn-info pl-5" href="#"><span class="icon-download"></span>{{"Statistiques.Telecharger" | translate}}</a>
          </div>
        </div> 
      </div>-->
      <table class="row slickpress slickContent" data-aos="fade-up" style="width: 100%;">
        <thead>
          <tr>
            <th style="min-width: 250px;"></th>
            <th style="min-width: 250px;"></th>
            <th style="min-width: 250px;"></th>
          </tr>
        </thead>
      </table>
    </div>
  </section>

</main>